<h3>{{ "i18n.base.two-factor-authentication.step-registration-successful.header" | translate }}</h3>
<div class="form-group">
  <p>{{ "i18n.base.two-factor-authentication.step-registration-successful.description" | translate }}</p>
</div>
<button class="btn btn-primary btn-right" (click)="onLogin()">
  {{ "i18n.core.navigation.login" | translate }}
</button>
